const displayDropdown = () => {
    document.addEventListener("click", (e) => {
        const isDropdownButton = e.target.matches("[data-dropdown-button]");
        const width = window.innerWidth;
        // clicking outside dropdown
        if (!isDropdownButton && e.target.closest("[data-dropdown]") != null)
            return;
        let currentDropdown;
        if (isDropdownButton) {
            currentDropdown = e.target.closest("[data-dropdown]");
            // show -> hide
            currentDropdown.classList.toggle("active");
            if (e.target === document.querySelector('.c-filters__button') || e.target === document.querySelector('.c-filters.element-sticky') && width < 1200) {
                document.body.classList.toggle('filters-active');
            }
        }
        // closing every dropdown except the one just clicked
        document
            .querySelectorAll("[data-dropdown].active")
            .forEach((dropdown) => {
                if (dropdown === currentDropdown || e.target.classList.contains('date-filled-static')) return;
                dropdown.classList.remove("active");
            });
    });
};

export default displayDropdown;
